import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class ClientRegistration {
    public readonly accountId: string;
    public readonly primaryStoreCategoryId: number;
    public readonly primaryStoreCategoryName: string;
    public readonly hasCustomCatchments: boolean;

    constructor(
        accountId: string,
        primaryStoreCategoryId: number,
        primaryStoreCategoryName: string,
        hasCustomCatchments: number | boolean
    ) {
        this.accountId = accountId;
        this.primaryStoreCategoryId = primaryStoreCategoryId;
        this.primaryStoreCategoryName = primaryStoreCategoryName;
        this.hasCustomCatchments = Boolean(hasCustomCatchments);
    }
}

export const loadClientRegistration = (): AppThunk<Promise<ClientRegistration>> => async (dispatch) => {
    try {
        const query = {
            dimensions: [
                "ClientRegistration.ClientID",
                "ClientRegistration.StoreCategory_ID",
                "ClientRegistration.PrimaryCategory",
                "ClientRegistration.HasCustomCatchments"
            ]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        const rawData = resultSet.rawData();
        return new ClientRegistration(
            rawData[0]["ClientRegistration.ClientID"],
            Number(rawData[0]["ClientRegistration.StoreCategory_ID"]),
            rawData[0]["ClientRegistration.PrimaryCategory"],
            Boolean(rawData[0]["ClientRegistration.HasCustomCatchments"]),
        );

    } catch (error) {
        dispatch(logError("Error loading ClientRegistration.", error));
        throw error;
    }
};
